/// list ///
export const WEBAPP_PRICELIST_CLICKEDADD = 'WEBAPP_PRICELIST_CLICKEDADDITEM';
export const WEB_PRICELIST_FILTEREDLIST = 'WEBAPP_PRICELIST_FILTEREDLIST';
export const WEBAPP_PRICELIST_CLICKEDPRICEITEM =
  'WEBAPP_PRICELIST_CLICKEDPRICEITEM';
export const WEBAPP_PRICELIST_BULKSELECT = 'WEBAPP_PRICELIST_BULKSELECT';
export const WEBAPP_PRICELIST_CHANGETABLEPAGE =
  'WEBAPP_PRICELIST_CHANGETABLEPAGE';
export const WEBAPP_PRICELIST_BULKDELETE = 'WEBAPP_PRICELIST_BULKDELETE';

/// form ///

export const WEBAPP_PRICEITEM_CLICKEDNAME = 'WEBAPP_PRICELISTITEM_CLICKEDNAME';
export const WEBAPP_PRICEITEM_CLICKEDDESCRIPTION =
  'WEBAPP_PRICELISTITEM_CLICKEDDESCRIPTION';
export const WEBAPP_PRICEITEM_CLICKEDPRICE =
  'WEBAPP_PRICELISTITEM_CLICKEDPRICE';
export const WEBAPP_PRICEITEM_CLICKEDVATRATE =
  'WEBAPP_PRICELISTITEM_CLICKEDVATRATE';
export const WEBAPP_PRICEITEM_CLICKEDCATEGORY =
  'WEBAPP_PRICELISTITEM_CLICKEDCATEGORY';
export const WEBAPP_PRICEITEM_CLICKEDUNIT = 'WEBAPP_PRICELISTITEM_CLICKEDUNIT';
export const WEBAPP_PRICEITEM_CLICKEDSUBMIT =
  'WEBAPP_PRICELISTITEM_CLICKEDSUBMIT';
export const WEBAPP_PRICEITEM_CLICKEDDELETE =
  'WEBAPP_PRICELISTITEM_CLICKEDDELETE';
